import React, { ReactNode } from 'react';
import classNames from 'classnames';
import EditableFieldRedux, { EditableFieldReduxProps } from './EditableFieldRedux';
import styles from './styles/EditableCellRedux.module.css';

export type EditableCellReduxProps = (
	| (EditableFieldReduxProps & { render?: never }) |
	{ render: () => ReactNode }
) & {
	className?: string;
	draggable?: boolean;
	missing?: boolean;
	row?: any;
	'data-testid'?: string;
};

export const EditableCellRedux = (
	props: EditableCellReduxProps,
) => {
	const {
		render,
		className,
		draggable,
		missing,
		['data-testid']: dataTestId,
	} = props;

	if (render != null) {
		return (
			<td
				className={classNames(className, { [`${styles.missing}`]: missing })}
				draggable={draggable}
				data-testid={dataTestId}
			>
				<div>
					{render()}
				</div>
			</td>
		);
	}

	if (props.type == null) {
		return null;
	}

	return (
		<td
			className={classNames(className, { [`${styles.missing}`]: missing })}
			draggable={draggable}
			data-testid={dataTestId}
		>
			<div>
				<EditableFieldRedux
					{...props}
				/>
			</div>
		</td>
	);
};

export default EditableCellRedux;
